import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Coverage Type"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Name of Insured"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Expiration")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createVNode("td", null, null, -1)
const _hoisted_11 = {
  type: "button",
  ref: "sealProEncodeModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#encode_new_sealpro_coverage_modal`
}
const _hoisted_12 = {
  type: "button",
  ref: "sealProEmailActivationModalButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#sealpro_email_activationlink_modal`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_SealProEncode = _resolveComponent("SealProEncode")
  const _component_SealProEmailActivation = _resolveComponent("SealProEmailActivation")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("table", _hoisted_3, [
            _hoisted_4,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, "   " + _toDisplayString(index + 1), 1),
                  _createVNode("td", null, _toDisplayString(item.sealpro_type_desc), 1),
                  (item.name_of_insured != '')
                    ? (_openBlock(), _createBlock("td", _hoisted_5, [
                        (item.sealpro_application_id !== null)
                          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(item.name_of_insured) + " - (" + _toDisplayString(_ctx.formatDate(item.form_date)) + ") ", 1))
                          : _createCommentVNode("", true),
                        (item.sealpro_application_id == null && item.email_to !=='')
                          ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(item.name_of_insured) + " - (" + _toDisplayString(_ctx.formatDate(item.email_date)) + ") ", 1))
                          : _createCommentVNode("", true),
                        (item.sealpro_application_id == null && item.email_to !=='')
                          ? (_openBlock(), _createBlock("br", _hoisted_8))
                          : _createCommentVNode("", true),
                        (item.sealpro_application_id == null && item.email_to !=='')
                          ? (_openBlock(), _createBlock("button", {
                              key: 3,
                              type: "button",
                              onClick: ($event: any) => (_ctx.showEmailActivationForm(item)),
                              class: "btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1"
                            }, " Resend Email ", 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_9, [
                        false
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-success er fs-4 px-8 py-2 mt-1 mb-1 me-2",
                              onClick: ($event: any) => (_ctx.showSealProApplicationForm(item.spcode,item.recid))
                            }, " Encode Now ", 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (item.emailable === 1)
                          ? (_openBlock(), _createBlock("button", {
                              key: 1,
                              type: "button",
                              onClick: ($event: any) => (_ctx.showEmailActivationForm(item)),
                              class: "btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1"
                            }, " Email Activation ", 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])),
                  _createTextVNode(" " + _toDisplayString(item.expiry_date == null ? "" : _ctx.formatDate(item.expiry_date)) + " ", 1),
                  _hoisted_10
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ]),
    _withDirectives(_createVNode("button", _hoisted_11, " Click here ", 512), [
      [_vShow, false]
    ]),
    _createVNode(_component_SealProEncode, {
      key: _ctx.sealproencodekey,
      sealpro_encode_modal: 'encode_new_sealpro_coverage_modal',
      allowClose: _ctx.allowClose,
      inputActivationDetail: true,
      spcode: _ctx.spcode,
      isAddAccount: false
    }, null, 8, ["allowClose", "spcode"]),
    _withDirectives(_createVNode("button", _hoisted_12, " Click here ", 512), [
      [_vShow, false]
    ]),
    _createVNode(_component_SealProEmailActivation, {
      key: _ctx.coverage_id,
      fullname: _ctx.fullname,
      emailto: _ctx.emailto,
      contactno: _ctx.contactno,
      coverage_id: _ctx.coverage_id,
      coverage_type: _ctx.coverage_type
    }, null, 8, ["fullname", "emailto", "contactno", "coverage_id", "coverage_type"])
  ], 64))
}